import { StrapiCreate, StrapiUpdate } from './../../types/strapi/strapi'
import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Calculation from '../../types/api/calculation'
import Strapi, { EndpointQueryParameters, StrapiSingle } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'

export const calculationsApi = createApi({
    reducerPath: 'calculationsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Calculations'],
    endpoints: builder => ({
        // getCalculations: builder.query<Strapi<Calculation>, EndpointQueryParameters | void>({
        //     query: getQuery('/calculations'),
        //     providesTags: ['Calculations'],
        // }),
        getMyCalculations: builder.query<Strapi<Calculation>, EndpointQueryParameters | void>({
            query: getQuery('/calculations/my'),
            providesTags: ['Calculations'],
        }),
        createCalculation: builder.mutation<StrapiSingle<Calculation>, StrapiCreate<Calculation>>({
            query: body => ({
                url: '/calculations',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Calculations'],
        }),
        updateCalculation: builder.mutation<StrapiSingle<Calculation>, StrapiUpdate<Calculation>>({
            query: ({ docId, body }) => ({
                url: `/calculations/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Calculations'],
        }),
        deleteCalculation: builder.mutation<void, string>({
            query: docId => ({ url: `/calculations/${docId}`, method: 'DELETE' }),
            invalidatesTags: ['Calculations'],
        }),
    }),
})

export const {
    // useGetCalculationsQuery,
    useGetMyCalculationsQuery,
    useCreateCalculationMutation,
    useUpdateCalculationMutation,
    useDeleteCalculationMutation,
} = calculationsApi
